import { gql } from '@apollo/client';

export const LIMIT = 50;

export const LIVESTREAM_TEST_SESSION = gql`
  query livestreamTestSession($id: ID!) {
    livestreamTestSession(id: $id) {
      id
      meetingTimeCounter
      timeZone
      firstName
      startAt
    }
  }
`;
